import * as THREE from 'three';

import * as mutationTypes from '../mutation-types';
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

const state = () => ({
  selectedDress: null,
  selectedClothes: [],
  selectedMesh: {},
  defaultDress: null,
  defaultTopDress: null,
  defaultBottomDress: null,
  clothes: [],
  loaders: {
    gltf: new GLTFLoader(),
  },
});

const getters = {
  defaultTopDress: state => state.defaultTopDress,
  defaultBottomDress: state => state.defaultBottomDress,
  defaultDress: state => state.defaultDress,
  selectedDress: state => state.selectedDress,
  selectedClothes: state => state.selectedClothes,
  selectedMesh: state => state.selectedMesh,
  clothes: state => state.clothes,
  clothesBySlot: (state) => (slot) => {
    return state.clothes.filter(el => el.slot === slot);
  },
  meshesOfDress: () => (dress) => {
    const meshes = [];

    function mapMesh(...array) {

      if(array.length) {
        array.map((child) => {

          if(child.type == 'Mesh') {

            if(!child.name.includes('NOT_') && !child.name.includes('ACC_')) {
              meshes.push(child);
            }

          } else {
            mapMesh(...child.children);
          }
        })
      }
    }

    // if (dress.inst.type == 'Mesh' ) {
    //   meshes.push(dress.inst);
    // } else {
    //   mapMesh(dress.inst.children);
    // }

    mapMesh(dress.inst);

    return meshes;
  },
  accessoriesOfDress: () => (dress) => {
    const meshes = [];

    function mapMesh(...array) {

      if(array.length) {
        array.map((child) => {

          if(child.type === 'Mesh') {

            if( !child.name.includes('NOT_') && child.name.includes('ACC_') ) {
              meshes.push(child);
            }

          } else {
            mapMesh(...child.children);
          }
        })
      }
    }

    mapMesh(dress.inst);
    // if (dress.inst.type === 'Mesh' ) {
    //   meshes.push(dress.inst);
    // } else {
    //   mapMesh(dress.inst.children);
    // }

    return meshes;
  },
  notOfDress: () => (dress) => {
    const meshes = [];

    function mapMesh(array) {

      if(array) {
        array.map((child) => {

          if(child.type === 'Mesh') {

            if(child.name.includes('NOT_') ) {
              meshes.push(child)
            }

          } else {
            mapMesh(child.children)
          }
        })
      }
    }

    if (dress.inst.type === 'Mesh' ) {
      meshes.push(dress.inst);
    } else {
      mapMesh(dress.inst.children);
    }

    return meshes;
  },
  selectedDressInClothes: (state, getters) => (clothes) => {
    if(getters.selectedClothes.length === 0) return null;
    //todo rimuovi o capire se serve ancora
    let found = null;

    clothes.forEach((dress) => {

      let el = getters.selectedClothes.find( el => el.id === dress.id);

      if(el) {
        found = el;
      }

    });

    return found;
  },
  dressById: (state) => (id) => {
    return state.clothes.filter(el => el.id === id)[0];
  }
};

const mutations = {
  [mutationTypes.PUSH_WORN_DRESS] (state,dress) {

    state.selectedClothes.unshift(dress);

  },
  [mutationTypes.UNWEAR_DRESS] (state,dress) {
    let i = state.selectedClothes.indexOf(dress);
    state.selectedClothes.splice(i,1);
    state.selectedMesh = {};
  },
  [mutationTypes.SET_SELECTED_DRESS] (state,dress) {
    state.selectedDress = dress;
    // console.log(dress);
    if(!dress) {
      state.selectedMesh = {};
    }
  },
  [mutationTypes.SET_SELECTED_MESH] (state,mesh) {
    // console.log(mesh);
    state.selectedMesh = mesh;
  },
  [mutationTypes.SET_MESH_COLOR] (state, color) {

    if(!state.selectedMesh.userData) {
      return;
    }
    state.selectedMesh.userData.color = color;

    if(state.selectedMesh.userData.backMesh) {
      state.selectedMesh.userData.backMesh.material.color = color;
      state.selectedMesh.userData.backMesh.material.map = null;
      state.selectedMesh.userData.backMesh.material.needsUpdate = true;
    }
    state.selectedMesh.material.color = color;
    state.selectedMesh.material.map = null;
    state.selectedMesh.material.needsUpdate = true;

  },
  [mutationTypes.SET_CLOTHES] (state,clothes) {
    // console.log('commit set clothes')
    state.defaultDress = clothes.filter( el => el.default && el.slot === 'mise')[0];
    // codice per gestire separatamente il top e il bottom
    // state.defaultTopDress = clothes.filter( el => el.default && el.slot === 'top')[0];
    // state.defaultBottomDress = clothes.filter( el => el.default && el.slot === 'bottom')[0];
    state.clothes = clothes//.filter( el => !el.default);
    // console.log(state.clothes,state.defaultBottomDress,state.defaultTopDress);
  }
};

const actions = {
  unwearDress: ({ commit, rootGetters },payload) => {

    const poser = rootGetters['mannequin/poser'];

    return new Promise( (resolve,reject) => {
      try {
        commit(mutationTypes.UNWEAR_DRESS,payload);
        poser.inst.remove(payload.inst);

        // const meshes = rootGetters['mannequin/meshesOf'](payload.inst);

        // meshes.forEach(m => {
        //   const backMesh = m.userData.backMesh;
        //   if(backMesh) {  
        //     backMesh.parent.remove(backMesh);
        //   }
        // });

        resolve(payload);

      } catch (e) {
        reject(`An error happened: ${e}`);
      }
    })

  },
  unwearAll: ({dispatch, state}) => {
    // console.log('unwearAll')
    return new Promise( (resolve,reject) => {
      try {

        if(state.selectedClothes.length === 0) {
          resolve();
        } else {
          dispatch('unwearDress', state.selectedClothes[0]).then(()=>{

            if(state.selectedClothes.length > 0) {
              dispatch('unwearAll',state.selectedClothes).then(() => {
                resolve();
              });
            } else {
              // console.log('fine di unwearAll', [...payload]);
              resolve();
            }

          });
        }



      } catch (e) {
        reject(`An error happened: ${e}.`);
      }
    });
  },
  wearDress: ({commit, rootGetters, dispatch },payload) => {
    return new Promise( (resolve,reject) => {

      // console.log('wearDress',[...state.selectedClothes]);
      try {

        if(payload.inst instanceof THREE.Group || payload.inst instanceof THREE.Object3D) {

          const poser = rootGetters['mannequin/poser'];

          // console.log(state.selectedClothes);

          // if(!payload.default) {

            dispatch('unwearAll').then(() => {

              // codice per gestire separatamente il top e il bottom
              // if(payload.slot === 'top') {
              //   commit(mutationTypes.PUSH_WORN_DRESS,state.defaultBottomDress);
              //   poser.inst.add(state.defaultBottomDress.inst);
              // } else if(payload.slot === 'bottom') {
              //   commit(mutationTypes.PUSH_WORN_DRESS,state.defaultTopDress);
              //   poser.inst.add(state.defaultTopDress.inst);
              // } else if(payload.slot === 'over') {
              //   commit(mutationTypes.PUSH_WORN_DRESS,state.defaultBottomDress);
              //   poser.inst.add(state.defaultBottomDress.inst);
              //   commit(mutationTypes.PUSH_WORN_DRESS,state.defaultTopDress);
              //   poser.inst.add(state.defaultTopDress.inst);
              // } else { //payload.slot === 'mise'
              //   // console.log('hai indossato una mise');
              // }

              commit(mutationTypes.PUSH_WORN_DRESS,payload);
              // payload.inst.renderOrder = 50;
              poser.inst.add(payload.inst);
              // console.log(payload.inst);

              // if id_shoes is set get the shoes by id or get default shoes if id_shoes is not set or id_shoes do not match any shoes
              const shoes = payload.id_shoes ? rootGetters['shoes/shoesById'](payload.id_shoes) || rootGetters['shoes/defaultShoes'] : rootGetters['shoes/defaultShoes'];

              dispatch('shoes/setSelectedShoes',shoes,{root: true} ).then(() => {

                return dispatch('setSelectedDress',payload);

              }).then(() => {
                dispatch('render',null,{root:true});
                resolve(payload);
              });

            });

          // }

          // commit(mutationTypes.PUSH_WORN_DRESS,payload);
          // // payload.inst.renderOrder = 50;
          // poser.inst.add(payload.inst);
          // return dispatch('setSelectedDress',payload).then(() => {
          //   resolve(payload);
          // });

        } else {

          dispatch('uploadDress',payload).then(() => {
            dispatch('wearDress',payload).then(() => {
                  resolve();
                });
          })
        }

      } catch (e) {
        reject(`An error happened: ${e}`);
      }

    })

  },
  uploadDress: ({ state, dispatch, getters, rootGetters }, payload) => {
    return new Promise((resolve,reject) => {
      try {

        state.loaders.gltf.load(payload.src,(gltf) => {
          payload.inst = gltf.scene;

          // console.log(gltf);

          //quando carico il modello per la prima volta allora applico a tutte le sue mesh (non accessories) il materiale di default
          let meshes = getters['meshesOfDress'](payload);

          meshes.forEach( async (el) => {
            // console.log('mesh: ',el);
            await dispatch('fabrics/applyFabric',{ payload: rootGetters['fabrics/defaultFabric'], mesh: el },{root:true});
          });


          //rimpiazzo il materiale del modello con uno pulito e gli applicalo le texture
          let notties = getters['notOfDress'](payload);
          notties.forEach( async (not) => {

            let newMat = new THREE.MeshStandardMaterial();

            newMat.color = new THREE.Color('#ffffff');
            newMat.side = THREE.DoubleSide;
            newMat.map = not.material.map ? not.material.map.clone() : null;

            // newMat.bumpMap ? newMat.bumpMap.magFilter = THREE.NearestFilter : null;
            // newMat.bumpScale = 0.05;

            newMat.alphaMap = not.material.alphaMap ? not.material.alphaMap.clone() : null;
            newMat.normalMap = not.material.normalMap ? not.material.normalMap.clone() : null;

            await dispatch('fabrics/disposeMaterial', not.material,{root:true} );

            not.material = newMat;

          } );

          //rimpiazzo il materiale del modello con uno pulito e gli applicalo le texture
          let accessories = getters['accessoriesOfDress'](payload);
          accessories.forEach( async (acc) => {
            // console.log('mesh: ',el);
            // await dispatch('fabrics/applyFabric',{ payload: rootGetters['fabrics/defaultFabric'], mesh: el },{root:true});

            // console.log(acc);
            let newMat = new THREE.MeshStandardMaterial();

            newMat.color = new THREE.Color('#000000');
            newMat.side = THREE.DoubleSide;
            newMat.bumpMap = acc.material.bumpMap ? acc.material.bumpMap.clone() : null;

            // newMat.bumpMap ? newMat.bumpMap.magFilter = THREE.NearestFilter : null;

            newMat.bumpScale = 0.05;
            newMat.alphaMap = acc.material.alphaMap ? acc.material.alphaMap.clone() : null;
            newMat.normalMap = acc.material.normalMap ? acc.material.normalMap.clone() : null;
            // newMat.normalScale = new THREE.Vector2(1.0,1.0);
            // acc.flatShading()
            // newMat.flatShading = false;

            await dispatch('fabrics/disposeMaterial', acc.material,{root:true} );

            acc.material = newMat;
          });

          payload.loaded = true;
          resolve(gltf);
        });

      } catch(e) {
        reject(`An error occurred: ${e}.`);
      }
    })
  },
  setSelectedDress: ({ commit, dispatch, getters }, payload) => {
    commit(mutationTypes.SET_SELECTED_DRESS,payload);
    //console.log(payload.inst.children);
    if(!payload.inst) {
      return;
    }


    let meshes = getters['meshesOfDress'](payload);
    if(meshes.length > 0)
      dispatch('setSelectedMesh',meshes[0]);
    // else if(payload.inst.children && payload.inst.children.length >= 1 && payload.inst.children[0] instanceof THREE.Mesh) {
    //   dispatch('setSelectedMesh',payload.inst.children[0]);
    // } else if(payload.inst.children[0].children && payload.inst.children[0].children[0] instanceof THREE.Mesh ) {
    //   dispatch('setSelectedMesh',payload.inst.children[0].children[0]);
    // }
    else {
      dispatch('setSelectedMesh',{});
    }
  },
  setSelectedMesh: ({ commit }, payload) => {
    // console.log(payload);
    commit(mutationTypes.SET_SELECTED_MESH,payload);
    // console.log('mesh:',payload);
    // console.log('before must set selected texture',payload.material.userData.texture)

    // console.log(payload);

    if(payload.material.userData.texture) {

      commit('textures/'+mutationTypes.SET_SELECTED_TEXTURE,payload.material.userData.texture,{root: true});
    } else {
      commit('textures/'+mutationTypes.SET_SELECTED_TEXTURE,null,{root: true});
    }

    if(payload.material.color) {
      commit('textures/'+mutationTypes.SET_SELECTED_COLOR,'#'+payload.material.color.getHexString(),{root: true});
    } else {
      commit('textures/'+mutationTypes.SET_SELECTED_COLOR,'#ffffff',{root: true});
    }


  },
  setMeshColor: ({ commit, dispatch, rootGetters }, payload) => {
    return new Promise((resolve,reject) => {
      try {
        // console.log('setMeshColor:',payload);

        let color = new THREE.Color(payload);
        commit(mutationTypes.SET_MESH_COLOR,color);
        dispatch('textures/setSelectedColor',payload,{root:true});
        dispatch('textures/resetTexture',rootGetters['clothes/selectedMesh'],{root:true});
        resolve(color);

      } catch(e) {
        reject(`an error occurred: ${e}.`);
      }
    });
  },
  disposeMesh: ({ dispatch },payload) => {

    //receive the mesh and dispose buffer geometry, then dispatch the disposeMaterial action
    dispatch('fabrics/disposeMaterial',payload.material,{root:true});
    payload.geometry.dispose();
    // console.log('texture dispose: ',payload);
    payload = null;
  },
  setClothes: ({ commit }, payload) => {
    return new Promise( (resolve,reject) => {
      commit(mutationTypes.SET_CLOTHES,payload);

      // dispatch('setSelectedDress',payload.filter(el => el.default)[0]);

      try {

        resolve();
        // dispatch('clothesPreloading').then( () => {
        //   // console.log('fine di dclothes preloading');
        // });


      } catch (e) {
        reject(`an error occurred: ${e}.`);
      }

    });
  },
  clothesPreloading: async ({ state, dispatch }) => {
    // console.log('preloading clothes',state.clothes.filter(el => !el.inst).length);

    state.clothes.forEach( async el => {
      if(!el.inst)
        await dispatch('uploadDress',el);
    })


  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}